import { useMemo } from 'react'

import { useAppSelector } from './redux.hook'
import { selectCurrentUser } from '../app/features/auth/auth.slice'

export const useAuth = () => {
  const user = useAppSelector(selectCurrentUser)

  return useMemo(() => ({ user }), [user])
}